import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectUser } from "../../../core/auth/authSlice";
import { User } from "../../../shared/models";
import SelectCartellinoStatus from "../components/SelectCartellinoStatus";
import SelectLocation from "../components/SelectLocation";
import SelectStaff from "../components/SelectStaff";

const Step2PersonalInfo: React.FC = () => {
	const { t } = useTranslation();
	const { accountType } = useSelector(selectUser) as User;
	const { watch } = useFormContext();
	const watchSubject = watch("subject");

	const personalInfoContent = useMemo(() => {
		switch (accountType) {
			case "athlete":
				switch (watchSubject) {
					case "team":
						return (
							<>
								<SelectLocation withAvailability />
								<SelectCartellinoStatus />
							</>
						);
					case "staff":
						return (
							<>
								<SelectLocation />
							</>
						);
					default:
						return null;
				}
			case "team":
				switch (watchSubject) {
					case "athlete":
						return (
							<>
								<SelectLocation />
							</>
						);
					case "staff":
						return (
							<>
								<SelectLocation />
							</>
						);
					default:
						return null;
				}
			case "techStaff":
			case "medStaff":
			case "management":
				return (
					<>
						<div className="row-group">
							<SelectStaff label={t("createJob.yourRole")} />
						</div>
						<SelectLocation withAvailability />
					</>
				);
			default:
				return null;
		}
	}, [watchSubject, accountType]);

	return <div className="step-content">{personalInfoContent}</div>;
};

export default Step2PersonalInfo;
